import { Component, EventEmitter, Input, Output } from '@angular/core';

import { CompanyService } from '../companies/company.service';
import { SessionService } from '../sessions/session.service';

@Component({
  template: require('./vendor.actions.component.html')
})
export class VendorActionsComponent {
  @Input() record: any;

  @Output() onEditClick         : EventEmitter<any> = new EventEmitter();
  @Output() onInvoiceClick      : EventEmitter<any> = new EventEmitter();
  @Output() onPurchaseOrderClick: EventEmitter<any> = new EventEmitter();
  @Output() onPaymentClick      : EventEmitter<any> = new EventEmitter();
  @Output() onSMSClick          : EventEmitter<any> = new EventEmitter();
  @Output() onEmailClick        : EventEmitter<any> = new EventEmitter();
  @Output() onActivateClick     : EventEmitter<any> = new EventEmitter();

  session = this.sessionService.base();

  constructor (
    private companyService: CompanyService,
    private sessionService: SessionService
  ) {}

  isDealer () : boolean {
    return this.companyService.isDealer();
  }
}
